/**
 * Zone.js flags for PAX A77 terminal compatibility
 * These flags must be set BEFORE zone.js is imported
 *
 * Fixes "Unable to preventDefault inside passive event listener" errors
 * on older WebView versions (Chrome 70)
 */

// Disable passive event listeners patching to allow preventDefault() calls
// This fixes the "Unable to preventDefault inside passive event listener" error
(window as any).__zone_symbol__PASSIVE_EVENTS = ['scroll', 'wheel', 'touchstart', 'touchmove', 'touchend'];

// Disable certain Zone.js patches that can cause issues on older browsers
// (window as any).__Zone_disable_requestAnimationFrame = true; // Uncomment if animations cause issues
// (window as any).__Zone_disable_on_property = true; // Uncomment if onProperty patching causes issues

// Black list certain events from being patched by Zone.js (improves performance)
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove', 'touchmove'];
